import { normalSanatizerBRL } from "src/utils/functions";
import { PixResponse } from "../utils/pix-parcelado";

export const PixParceladoTable = ({ results }: { results: PixResponse }) => {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">N° </th>
            <th className="px-4 py-2 text-center truncate">Prestação</th>
            <th className="px-4 py-2 text-center truncate">Juros</th>
            <th className="px-4 py-2 text-center truncate">Amortização</th>
            <th className="px-4 py-2 text-center truncate">Saldo devedor</th>
            {results.selectValorParcela ? null : (
              <th className="px-4 py-2 text-center truncate">
                Valor da Parcela
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {results.tabela.map((item) => (
            <tr key={item.parcela} className="border-b">
              <td className="px-4 py-2 text-center truncate border-r">
                {item.parcela}
              </td>
              <td className="px-4 py-2 text-center truncate border-r">
                R$ {normalSanatizerBRL(item.totalPrestacao)}
              </td>
              <td className="px-4 py-2 text-center truncate border-r">
                R$ {normalSanatizerBRL(item.juros)}
              </td>
              <td className="px-4 py-2 text-center truncate border-r">
                R$ {normalSanatizerBRL(item.amortizacao)}
              </td>
              <td className="px-4 py-2 text-center truncate border-r">
                R$ {normalSanatizerBRL(item.saldo)}
              </td>
              {results.selectValorParcela ? null : (
                <td className="px-4 py-2 text-center truncate border-r">
                  R$ {normalSanatizerBRL(item.valorFinalParcela)}
                </td>
              )}
            </tr>
          ))}
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r font-semibold">
              Totais
            </td>
            <td className="px-4 py-2 text-center truncate border-r font-semibold">
              R$ {normalSanatizerBRL(results.totais.totalPrestacao)}
            </td>
            <td className="px-4 py-2 text-center truncate border-r font-semibold">
              R$ {normalSanatizerBRL(results.totais.totalJuros)}
            </td>
            <td className="px-4 py-2 text-center truncate border-r font-semibold">
              R$ {normalSanatizerBRL(results.totais.totalAmortizacao)}
            </td>
            <td className="px-4 py-2 text-center truncate border-r font-semibold">
              -
            </td>
          </tr>
          <tr className="border-b">
            <td className="px-4 py-2 text-center truncate border-r font-semibold">
              Taxa de Juros Mensal do PIX
            </td>
            <td
              className="text-center px-4 py-2 truncate border-r font-semibold"
              colSpan={4}
            >
              {(results.totalTaxaMensal * 100).toFixed(2)}% a.m
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
